import { PacketValueSerialType } from "../enum/PacketValueSerialType";
import NetworkBehavior from "../lib/NetworkBehavior";
import { Time } from "../lib/Time";
import { Physics } from "../math/Physics";
import Vector2 from "../math/Vector2";
import Color from "../util/Color";
import Player from "./Player";

export class FlakShard extends NetworkBehavior {

    velocity = Vector2.zero;
    team: 'red'|'blue'|undefined;
    ownerName = "";
    damage = 1;
    lifetime = 15;
    born = Time.time;
    friction = 0.5;
    damageRange = 8;

    Die(playerHit?: Player) {

        if (this.isOwner && playerHit) {
            this.engine.sendDamagePacket(playerHit, this.damage);
            this.engine.sendUpdatePacket(playerHit, "PLAYER", [
                {
                    key: "velocity",
                    value: playerHit.velocity.scale(0.5),
                    type: PacketValueSerialType.Vector2
                }
            ]);

            this.engine.createExplosionForAll({
                position: this.transform.position,
                size: this.damageRange,
                color: this.engine.clientPlayer?.team === this.team ? Color.fromHex('#55ff55') : Color.fromHex('#ff5555')
            });
        }

        
        this.engine.RemoveGameObject(this.gameObject);
    }

    Update(): void {
        if (Time.time - this.born >= this.lifetime) {
            this.Die();
            return;
        }

        

        const validPlayers = this.engine.GetGameObjectsBehaviors<Player>(Player).filter(
            v => !v.isDead && v.team && v.team !== this.team
        );

        for (const player of validPlayers) {
            if (
                Physics.CircleCircleCollision({
                    position: this.transform.position,
                    radius: 4
                }, {
                    position: player.transform.position,
                    radius: player.size
                }) !== false
            ) {
                // this.engine.clientPlayer.Damage(this.damage);
                this.Die(player);
                return;
            }
        }

        this.velocity = this.velocity.sub(this.velocity.scale(this.friction * Time.deltaTime));
        this.transform.position = this.transform.position.add(this.velocity.scale(Time.deltaTime));
        this.transform.rotation = this.velocity.normalized;
    }

    Draw(): void {
        this.ctx.lineWidth = 2;
        this.ctx.strokeStyle = this.engine.clientPlayer?.team === this.team ? '#55ff55' : '#ff5555';

        this.engine.Line(this.transform.position.add(this.transform.forward.scale(4)), this.transform.position.add(this.transform.back.scale(4)));
        this.engine.Line(this.transform.position.add(this.transform.left.scale(4)), this.transform.position.add(this.transform.right.scale(4)));
    }

    DrawGizmos(): void {
        this.ctx.fillStyle = '#55ff5555';
        this.engine.FillRect(this.transform.position.add(new Vector2(-25, 8)), new Vector2(50, 4));
        this.ctx.fillStyle = '#55ff55';
        this.engine.FillRect(this.transform.position.add(new Vector2(-25, 8)), new Vector2(50 * (1 - (Time.time - this.born)/this.lifetime), 4));
    }

}